import { render, staticRenderFns } from "./dialogForgetPassword.vue?vue&type=template&id=53ae1a47&scoped=true"
import script from "./dialogForgetPassword.vue?vue&type=script&lang=js"
export * from "./dialogForgetPassword.vue?vue&type=script&lang=js"
import style0 from "./dialogForgetPassword.vue?vue&type=style&index=0&id=53ae1a47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ae1a47",
  null
  
)

export default component.exports